export default __webpack_public_path__ + "static/media/ic_3_arrows_up_48px.beece484.svg";